export const SHIMMERING_DIV_HEIGHT_SINGLE_ADGROUPS = '40px';
